import { NamespaceConsumer, withNamespace } from '@ux/namespace-component';
import NavigationHelp from './navigation-help';
import React from 'react';

class Header extends NamespaceConsumer {

  render() {
    const props = this.props;

    const classNames = this.namespace(this.classNames(
      'manifest',
      { 'mobile-nav-seo': props.mobileSEO }
    ));

    return (
      <header className={ classNames }>
        <div className={ this.namespace('nav-top-stroke') }>&nbsp;</div>
        <NavigationHelp { ...props } />
      </header>
    );
  }
}

export default withNamespace(Header);
